export const DottedRoundCheck = ({ size = "20" }: { size?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="13" height="13" rx="6.5" fill="#F8FDF7" />
      <rect
        x="0.5"
        y="0.5"
        width="13"
        height="13"
        rx="6.5"
        stroke="currentColor"
        stroke-dasharray="2 2"
      />
      <path
        d="M4.59375 6.93862L6.09375 8.32494L9.59375 5.08984"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
